// extracted by mini-css-extract-plugin
export default {"editor":"Note_editor__c6GYh"};